export function mid(bbo){return bbo.bid.plus(bbo.ask).dividedBy(2);}